import React, { useState } from "react";  
import "./Chatbot.css";  
import Logo from '../images/Metso-logo1.png';  
  
const Chatbot = () => {  
  const [isOpen, setIsOpen] = useState(false);  
  const [messages, setMessages] = useState([]);  
  const [userInput, setUserInput] = useState("");  
  
  const handleToggle = () => {  
    setIsOpen(!isOpen);  
  };  
  
  const sendMessageToBackend = async (userMessage) => {  
    setMessages((prevMessages) => [...prevMessages, { text: userMessage, sender: "user" }]);  
  
    try {  
      // Send user message to backend  
      await fetch("/usermessage", {  
        method: "POST",  
        headers: {  
          "Content-Type": "application/json",  
        },  
        body: JSON.stringify({ message: userMessage }),  
      });  
  
      // Fetch bot response from backend  
      const response = await fetch("/botmessage", {  
        method: "GET",  
        headers: {  
          "Content-Type": "application/json",  
        },  
      });  
  
      const data = await response.json();  
      const botMessage = data.message || "Sorry, I couldn't process that.";  
  
      setMessages((prevMessages) => [...prevMessages, { text: botMessage, sender: "bot" }]);  
    } catch (error) {  
      console.error("Error fetching AI response:", error);  
      setMessages((prevMessages) => [  
        ...prevMessages,  
        { text: "Oops! Something went wrong.", sender: "bot" },  
      ]);  
    }  
  };  
  
  const handleUserInput = (e) => {  
    if (e.key === "Enter" && userInput.trim() !== "") {  
      sendMessageToBackend(userInput.trim());  
      setUserInput("");  
    }  
  };  
  
  const handleSendClick = () => {  
    if (userInput.trim() !== "") {  
      sendMessageToBackend(userInput.trim());  
      setUserInput("");  
    }  
  };  
  
  return (  
    <div>  
      <div className="chatbot-icon" onClick={handleToggle}>  
        🤖{/*🤖💬*/}  
      </div>  
      {isOpen && (  
        <div className="chatbot-container">  
          <div className="chatbot-header">  
            <div className="chatbot-avatar">  
              <img src={Logo} alt="Logo" className="Logo" />  
            </div>  
            <div className="chatbot-name">Virtual Assistant</div>  
            <button className="close-button" onClick={handleToggle}>  
              ×  
            </button>  
          </div>  
          <div className="chatbot-messages">  
            {messages.map((msg, index) => (  
              <div key={index} className={`chat-message ${msg.sender}`}>  
                {msg.text}  
              </div>  
            ))}  
          </div>  
          <div className="chatbot-footer">  
            <input  
              type="text"  
              placeholder="Type a message..."  
              value={userInput}  
              onChange={(e) => setUserInput(e.target.value)}  
              onKeyDown={handleUserInput}  
            />  
              <button className="send-button" onClick={handleSendClick}>  
              ➤  
            </button> 
          </div>  
        </div>  
      )}  
    </div>  
  );  
};  
  
export default Chatbot;  